<fieldset>
    <legend class="form-label">
        {{model.config.title}}
    </legend>
    <paetep-signature formControlName="answer" [isPrintMode]="isPrintMode" [hideActionsWhenDisabled]="true">
        <div><span class="small">Signature of {{getSignatureTypeLabel()}}: {{signatureName}}</span></div>
        <div><span class="small">Sign Date: {{signatureDate | date}}</span></div>
    </paetep-signature>
</fieldset>
